import { NgModule } from '@angular/core';
import { FtSwiperDirective } from './ft-swiper.directive';

@NgModule({
    declarations: [FtSwiperDirective],
    exports: [FtSwiperDirective]
})
export class FtSwiperModule {}
